import React from "react";

export const useSteps = () => {
  const [step, setStep] = React.useState<number>(1);
  const stepUp = () => setStep(step + 1);
  const stepDown = () => setStep(step === 1 ? 1 : step - 1);
  return { step, setStep, stepUp, stepDown };
};
